import async from 'components/Async';
import { access } from 'constants/index';

const ReportApiDocsPage = async(() => import('./ReportApiDocsPage'));
const ReportApiAuthenticationPage = async(() => import('./ReportApiAuthenticationPage'));
const SponsoredAdsReportApiDocsPage = async(() => import('./SponsoredAdsReportApiDocsPage'));

/*
 * Partner-facing documentation pages. Explicit access (instead of the pageAccess URL map)
 * because '/docs/*' has no accessPathNodes entry — docs are visible to every partner role.
 */
const docsRouteList = [
   {
      path: '/docs/report-api-authentication',
      component: ReportApiAuthenticationPage,
      access: access.byRole.partner.all,
   },
   {
      path: '/docs/sponsored-ads-report-api',
      component: SponsoredAdsReportApiDocsPage,
      access: access.byRole.partner.all,
   },
   {
      path: '/docs/report-api',
      component: ReportApiDocsPage,
      access: access.byRole.partner.all,
   },
];

export default docsRouteList;
